import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { MenuServices } from "../../services";
import { DishServices } from "../../../dish/services";
import { StaticsServices } from '../../../services/statics';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MenuCreateDishSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-create-extras',
  templateUrl: 'menu-create-extras.html',
})
export class MenuCreateExtrasPage {

  update_state: boolean = false;
  menu_uid: string;
  menu_name: string;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public menuServices: MenuServices,
    public dishServices: DishServices,
    public toastCtrl: ToastController,
    public staticsServices: StaticsServices,
    public translate: TranslateService) {

    this.update_state = this.navParams.get('update');//Update state
    this.menu_uid = this.navParams.get('menu_uid');//Menu uid
    this.menu_name = this.navParams.get('menu_name');//Menu name

  }

  ionViewWillEnter() {
    this.menuServices.getPagesDishesProducts(0);
    this.menuServices.page_active = 1;

    if (this.menuServices.sections_extra_array_tmp != undefined) {
      this.menuServices.menu_dish_product_array_tmp = this.menuServices.sections_extra_array_tmp;
    } else {
      this.menuServices.menu_dish_product_array_tmp = [];
    }
  }

  updateSection() {
    //Preparamos el objecto para insertarlo en los extras_section del menu
    var _obj = {};
    for (var i = 0; this.menuServices.menu_dish_product_array_tmp.length > i; i++) {
      this.menuServices.sumands = this.menuServices.sumands + this.menuServices.menu_dish_product_array_tmp[i]['name_ca'];
      this.menuServices.count_tmp++;

      _obj[i] = {
        uid: this.menuServices.menu_dish_product_array_tmp[i]['uid'],
        type: this.menuServices.menu_dish_product_array_tmp[i]['type'],
        name: this.menuServices.menu_dish_product_array_tmp[i]['name'],
        name_ca: this.menuServices.menu_dish_product_array_tmp[i]['name_ca'],
        name_en: this.menuServices.menu_dish_product_array_tmp[i]['name_en'],
        name_de: this.menuServices.menu_dish_product_array_tmp[i]['name_de'],
        name_fr: this.menuServices.menu_dish_product_array_tmp[i]['name_fr'],
        name_it: this.menuServices.menu_dish_product_array_tmp[i]['name_it'],
        price_static: this.menuServices.menu_dish_product_array_tmp[i]['price_static'],
        price: this.menuServices.menu_dish_product_array_tmp[i]['price'],
        allergens: this.menuServices.menu_dish_product_array_tmp[i]['allergens'],
      };

      //this.globals.dataSet('menu_dish', this.menuServices.menu_dish_product_array_tmp[i][name], '', this.menuServices.menu_section_array_complete_tmp[this.section_index].name, '');

    }

    //

    this.menuServices.menu_section_array_complete_tmp = _obj; // Insertamos dish al menu
    this.menuServices.sections_extra_array_tmp = this.globals.objectToArray(this.menuServices.menu_section_array_complete_tmp);
    this.menuServices.menu_dish_product_array_tmp = Array(); //Limpiamos el array
  }

  updateFirestore() {
    this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
      'extras_section': this.menuServices.menu_section_array_complete_tmp,
    }).then(() => {
    });
  }

  update() {
    this.updateSection();
    this.updateFirestore();
    this.navCtrl.pop();
  }
  searchProductsDishesNode(value) {
    this.menuServices.searchProductsDishesNode(value);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-extras/menu-create-extras.ts